import React, { Component } from 'react';
import { connect } from 'react-redux';

@connect(({ auth: { user } }) => ({ user }))
class Badge extends Component {
  render() {
    let count = 0;

    const { user } = this.props;
    if (user) {
      if (!user.email || !user.status) {
        count++;
      }
    }

    return count ? (
      <span
        className="badge"
        style={{ marginTop: '-2px', marginLeft: '6px', background: 'red' }}
      >
        {count}
      </span>
    ) : null;
  }
}

export default Badge;
